import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=b153f0e6&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=ts"
export * from "./DeleteUser.vue?vue&type=script&lang=ts"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=b153f0e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b153f0e6",
  null
  
)

export default component.exports